import Social from "./Social.js"

export default Social;